/**=========================================================
 * Module: support.js
 * Support Controller
 =========================================================*/

 App.controller('SupportController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'DataService',
     function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, D) {
         "use strict";

         

                         $scope.mailForm = {
                             title: 'Contact support',
                             status: '',
                             type: 'action',
                             successLabel: 'labels.CONTACTSUPPORTRECEIVED',
                             model: { id: 'ContactSupport'  },
                             fields: [
                                 {
                                     available: true,
                                     type: 'editor',
                                     name: 'body'
                                 },{
                                     available: true,
                                     type: 'submit',
                                     name: 'submit',
                                     label: 'Send'
                                 }
                             ],
                             submit: function () {
                                 $scope.mailForm.status = 'submitting';
                                 D.save('action', $scope.mailForm.model).then(function (response) {
                                    $scope.mailForm.model = { id: 'ContactSupport'  };
                                     $scope.mailForm.status = 'submitted';
                                 }).catch(function (response) {
                                     $scope.mailForm.status = 'error';
                                 })
                             }
                         }

                     
    }

 ]);